import { useState } from "react";
import { toast } from "react-toastify";
import CustomerService from "../../../rest/customerService";
import NotificationsService from "../../../rest/notificationService";

export function useCustomerSelection(pagedData, reloadData) {
    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectAll = (e) => {
        if (e.target.checked && pagedData) {
            const allLogins = pagedData.map(item => item.login);
            setSelectedItems(allLogins);
        } else {
            setSelectedItems([]);
        }
    };

    const handleSelectItem = (login) => {
        setSelectedItems(prev => 
            prev.includes(login) ? prev.filter(id => id !== login) : [...prev, login]
        );
    };

    const clearSelection = () => setSelectedItems([]);

    const updateBatchGrades = async (newGrade) => {
        try {
            await CustomerService.updateBatchGrades({ logins: selectedItems, grade: newGrade });
            toast.success("Séries atualizadas com sucesso!");
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar séries.");
        }
    };

    const sendBatchBilling = async () => {
        try {
            await NotificationsService.sendBatchBilling(selectedItems);
            toast.success(`Cobrança enviada com sucesso para ${selectedItems.length} clientes!`);
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao emitir cobranças.");
        }
    };

    const updateBatchStatus = async (isActive) => {
        try {
            await CustomerService.updateBatchStatus(selectedItems, isActive);
            toast.success("Status atualizado com sucesso!");
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar status.");
        }
    };

    const sendBatchCredentials = async () => {
        try {
            await NotificationsService.resendCredentials(selectedItems);
            toast.success(`Processo de envio iniciado para ${selectedItems.length} usuários.`);
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao solicitar envio.");
        }
    };

    return {
        selectedItems,
        handleSelectAll,
        handleSelectItem,
        clearSelection,
        actions: {
            updateBatchGrades,
            sendBatchBilling,
            updateBatchStatus,
            sendBatchCredentials
        }
    };
}